import { combineReducers } from "redux";

import dashboard from "./dashboard.reducer";
import sensor from "./sensor.reducer";
import sensorLiveData from "./sensorLiveData.reducer";
import sensorTotalData from "./sensorTotalData.reducer";
import sensorTotalConsumption from "./sensorTotalConsumption.reducer";
import sensorGraph from "./sensorGraph.reducer";
import reports from "./reports.reducer";
import alerts from "./alerts.reducer";
import cycleReport from "./cycleReport.reducer";

const rootReducer = combineReducers({
  dashboard,
  sensor,
  sensorLiveData,
  sensorTotalData,
  sensorTotalConsumption,
  sensorGraph,
  reports,
  alerts,
  cycleReport
});

export default rootReducer;
